//Sample Note Class 
export class Note {
    id: number;
    notes: string;
    date: any; 
}
  